var Handlebars = require("/home/admin/gitlab_code/assets/enhancer/user-center-assets/node_modules/handlebars/runtime.js");
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.escapeExpression;

  return "<div class=\"captcha-tip\">\n	<a class=\"enhancer-close\">&times</a>\n  <h3>"
    + alias2(require("/home/admin/gitlab_code/assets/enhancer/user-center-assets/src/pages/register/i18n/index.js").call(alias1,"captchaTipTitle",{"name":"i18n","hash":{},"data":data}))
    + "</h3>\n  <ul class=\"captcha-tip-list\">\n    <li>"
    + alias2(require("/home/admin/gitlab_code/assets/enhancer/user-center-assets/src/pages/register/i18n/index.js").call(alias1,"captchaTip1",{"name":"i18n","hash":{},"data":data}))
    + "</li>\n    <li>"
    + alias2(require("/home/admin/gitlab_code/assets/enhancer/user-center-assets/src/pages/register/i18n/index.js").call(alias1,"captchaTip2",{"name":"i18n","hash":{},"data":data}))
    + "</li>\n    <li>"
    + alias2(require("/home/admin/gitlab_code/assets/enhancer/user-center-assets/src/pages/register/i18n/index.js").call(alias1,"captchaTip3",{"name":"i18n","hash":{},"data":data}))
    + "</li>\n  </ul>\n</div>";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/pages/register/captcha.html
// module id = 32
// module chunks = 0